import axios from 'axios';

const getv2AppConfigSchema = async (platform) => {
    const response = await axios.get(`/api/customizations/v2/app-config-schema/platform/${platform}`);
    return response.data;
};

const getAppSavedConfig = async (projectId, version, platform) => {
    const data = { projectId, version, platform };
    const response = await axios.post('/api/customizations/v2/app-saved-config', data);
    return response.data;
};

const storeAppConfig = async (projectId, version, config_type, config, platform) => {
    const data = { projectId, version, groupName: config_type, formdata: config, platform };
    const response = await axios.post('/api/customizations/v2/store-app-config', data);
    return response.data;
};

const getAppV2ConfigVersions = async (projectId, platform) => {
    const formdata = { projectId, platform };
    const response = await axios.post('/api/customizations/v2/app-config-versions', formdata);
    return response.data;
};

const uploadImage = async (projectId, fieldId, imageData, contentType) => {
    const data = { projectId, fieldId, imageData, contentType };
    const response = await axios.post('/api/customizations/v2/upload-image', data);
    return response.data;
};

const getV2Resources = async (payload) => {
    const response = await axios.post('/api/customizations/v2/get-resources', payload);
    return response.data;
};

export default {
    getAppSavedConfig,
    storeAppConfig,
    getAppV2ConfigVersions,
    uploadImage,
    getv2AppConfigSchema,
    getV2Resources,
};
